import React from 'react';
import parse, { Element, HTMLReactParserOptions } from 'html-react-parser';

interface ParserOptions extends HTMLReactParserOptions {
  addParagraphs?: boolean;
}

export const newLineToBr = (text: string) => text.replace(/\n+/g, '<br/>');
/*
  addParagraphs option replaces \n or <br /> with <p></p>.
  This allows us to emulate paragraphs with correct line-height spacing.

  Both Jetstar and Qantas appear to use \n and <br /> for various HTML strings.
*/
const htmlToReact = (
  htmlString: string = '',
  parserOptions: ParserOptions = {},
) => {
  // eslint-disable-next-line prefer-const
  let { addParagraphs, ...options } = parserOptions;
  let stringToParse = htmlString;

  if (addParagraphs) {
    stringToParse = newLineToBr(htmlString);

    options = {
      replace: (domNode) => {
        if (
          domNode instanceof Element &&
          domNode.attribs &&
          domNode.name === 'br'
        ) {
          // We want to render a standard <br /> if we're inside a paragraph
          /* @ts-ignore */
          if (domNode.parent?.name === 'p') {
            return <br />;
          }

          return <p />;
        }
      },
      ...options,
    };
  }

  return parse(stringToParse, options);
};

export default htmlToReact;
